module.exports = __webpack_public_path__ + "static/media/appios.9d06f37a.png";